import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { LOCALE_LIST } from '@/assets/constants/locale'
// import twLocaleData from '@/i18n/locales/zh-TW.json'
// import cnLocaleData from '@/i18n/locales/zh-CN.json'
import usLocaleData from '@/i18n/locales/en-US.json'
// import jpLocaleData from '@/i18n/locales/ja-JP.json'

Vue.use(VueI18n)

// const loadedLanguages = [] // our default language that is prelaoded
// const loadedLanguages = ['zh-TW'] // our default language that is prelaoded
const loadedLanguages = ['en-US'] // our default language that is prelaoded

function setI18nLanguage(locale) {
  i18n.locale = locale
  document.querySelector('html').setAttribute('lang', translateLocalePath(locale).htmlLang)
  return locale
}

function translateLocalePath(localeText) {
  let localPath = LOCALE_LIST.find((locale) => {
    return locale.locale.toLowerCase() === localeText.toLowerCase() || // Normally comapre with locale
      locale.countryCode.toLowerCase() === localeText.toLowerCase() || // Compatibility with countryCode (tw or us) for path
      locale.languageCode.toLowerCase() === localeText.toLowerCase() // Compatibility with languageCode e.g. zh & en to tw & us
  })
  if (localPath === undefined) {
    localPath = LOCALE_LIST[0] // default en
  }
  return localPath
}

// vue-i18n loadLanguageAsync
// Reference: http://kazupon.github.io/vue-i18n/guide/lazy-loading.html
export function loadLanguageAsync(localePath = 'us') {
  const matchedLocaleObj = translateLocalePath(localePath)
  if (matchedLocaleObj && (matchedLocaleObj.locale !== i18n.locale)) {
    const newLocale = matchedLocaleObj.locale

    if (!loadedLanguages.includes(newLocale)) {
      return import(/* webpackChunkName: "locale-msg-[request]" */ `@/i18n/locales/${newLocale}.json`)
        .then(msgs => {
          i18n.setLocaleMessage(newLocale, msgs)
          loadedLanguages.push(newLocale)
          return setI18nLanguage(newLocale)
        })
    }
    return Promise.resolve(setI18nLanguage(newLocale))
  }
  return Promise.resolve(matchedLocaleObj)
}

export const i18n = new VueI18n({
  locale: 'en-US',
  // fallbackLocale: 'en-US',
  messages: {
    // 'zh-TW': twLocaleData
    'en-US': usLocaleData
  }
})

// customized method
i18n.localePath = (link = '') => {
  const localePath = i18n.locale ? i18n.locale.split('-')[1].toLowerCase() : ''
  return `${localePath}${link}`
}
i18n.navigatorLocalePath = (link = '') => {
  const navigatorLang = (window.navigator && (window.navigator.userLanguage || window.navigator.language)) || ''
  // console.log('Navigator Language', navigatorLang)
  // navigatorLang > en-GB
  const navigatorLocalePath = translateLocalePath(navigatorLang).countryCode
  // console.log('navigator Locale Path', navigatorLocalePath)
  return `${navigatorLocalePath}${link}`
}
